import React from 'react'
import Prism from 'prismjs'
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace'
import 'prismjs/plugins/toolbar/prism-toolbar'
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-ini'
import 'prismjs/components/prism-apacheconf'
import 'prismjs/components/prism-nginx'

interface Props {
    code: string
    language: 'bash' | 'php' | 'css' | 'ini' | 'apacheconf' | 'nginx' | 'javascript'
}

export class CodeBlock extends React.PureComponent<Props> {
    componentDidMount() {
        Prism.highlightAll()
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
        Prism.highlightAll()
    }

    render = () => (
        <pre>
            <code className={`language-${this.props.language}`}>{this.props.code}</code>
        </pre>
    )
}
